import GitHubCalendar from 'react-github-calendar';
import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Heading,
  Text,
  Stack,
  StackDivider,
  Icon,
  useColorModeValue,
  Box,
  Center,
} from '@chakra-ui/react';
import { IoIosAnalytics, IoIosSearch } from 'react-icons/io';
import ProfilePic from '../assets/portfolio_image.png';

const Feature = ({ text, icon, iconBg }) => {
  return (
    <Stack direction={'row'} align={'center'}>
      <Flex
        w={8}
        h={8}
        align={'center'}
        justify={'center'}
        rounded={'full'}
        bg={iconBg}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{text}</Text>
    </Stack>
  );
};

export default function AboutMe() {
  return (
    <Box>
      <Container maxW={'10xl'} py={16} id={'aboutme'}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          <Stack spacing={4}>
            <Text
              textTransform={'uppercase'}
              color={'blue.400'}
              fontWeight={600}
              fontSize={'sm'}
              bg={useColorModeValue('blue.50', 'blue.900')}
              p={2}
              alignSelf={'flex-start'}
              rounded={'md'}
            >
              About Me
            </Text>
            <Heading>A Passionate Developer</Heading>
            <Text color={'gray.500'} fontSize={'lg'}>
              Hello, there! My name is Sanjaykumar Rathva. I am a MERN stack
              developer who holds a Post Graduation degree in Master of
              Technology in Modelling & Simulation. Learned full stack web
              development in 7 months along with hands-on 1200+ hours of coding
              and 300+ hours of problem solving experience and continue to grow!
              Looking for full-time opportunity.
            </Text>
            <Stack
              spacing={4}
              divider={
                <StackDivider
                  borderColor={useColorModeValue('gray.100', 'gray.700')}
                />
              }
            >
              <Feature
                icon={
                  <Icon as={IoIosAnalytics} color={'yellow.500'} w={5} h={5} />
                }
                iconBg={useColorModeValue('yellow.100', 'yellow.900')}
                text={'Project Planning'}
              />
              <Feature
                icon={
                  <Icon as={IoIosSearch} color={'purple.500'} w={5} h={5} />
                }
                iconBg={useColorModeValue('purple.100', 'purple.900')}
                text={'Digital Marketing'}
              />
            </Stack>
          </Stack>
          <Flex justifyContent={'flex-end'}>
            <Image
              rounded={'md'}
              alt={'feature image'}
              src={`${ProfilePic}`}
              objectFit={'cover'}
            />
          </Flex>
        </SimpleGrid>
      </Container>
      <Container maxW={'10xl'}>
        <Stack spacing={4}>
          <Text
            textTransform={'uppercase'}
            color={'blue.400'}
            fontWeight={600}
            fontSize={'sm'}
            bg={useColorModeValue('blue.50', 'blue.900')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}
          >
            GitHub Stats
          </Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
            <Center>
              <Image
                w={'100%'}
                src="https://github-readme-stats.vercel.app/api?username=sanjayrathva091&show_icons=true&theme=radical"
              ></Image>
            </Center>
            <Center>
              <Image
                w={'100%'}
                h={'100%'}
                src="https://github-readme-stats.vercel.app/api/top-langs/?username=sanjayrathva091&layout=compact&theme=radical"
              ></Image>
            </Center>
          </SimpleGrid>
          <Box display={'flex'} justifyContent={'center'}>
            <Image
              w={'2xl'}
              src="https://github-readme-streak-stats.herokuapp.com/?user=sanjayrathva091&show_icons=true&locale=en&theme=gruvbox"
            ></Image>
          </Box>
        </Stack>
      </Container>
      <Container maxW={'10xl'}>
        <Stack spacing={4}>
          <Text
            textTransform={'uppercase'}
            color={'blue.400'}
            fontWeight={600}
            fontSize={'sm'}
            bg={useColorModeValue('blue.50', 'blue.900')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}
          >
            GitHub Calendar
          </Text>
          <Center>
            <GitHubCalendar
              username="sanjayrathva091"
              fontSize={16}
              blockSize={16}
              showWeekdayLabels={true}
            />
          </Center>
        </Stack>
      </Container>
    </Box>
  );
}
